// extracted by mini-css-extract-plugin
export default {"switch":"styles_switch__HA9Jh","slider":"styles_slider__DclAg","input":"styles_input__s7EOC"};